// Core
import { ProfileData } from "@/domains/profile/types";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export type UserType = {
  isAuth: boolean;
  token: string | null;
  user: ProfileData | null;
  setUser: (user: ProfileData) => void;
  getUser: () => ProfileData | null;
  getIsAuth: () => boolean;
  setIsAuth: (isAuth: boolean) => void;
  getToken: () => string | null;
  setToken: (token: string) => void;
  logout: () => void;
  login: (user: ProfileData) => void;
  setUserBalance: (balance: number) => void;
};

const UserStore = create(
  devtools(
    persist<UserType>(
      (_set, _get) => ({
        isAuth: false,
        token: null,
        user: null,
        login: (user: ProfileData) => _set({ isAuth: true, user }),
        logout: () => _set({ isAuth: false, user: null, token: null }),
        getUser: () => _get().user,
        getIsAuth: () => _get().isAuth,
        getToken: () => _get().token,
        setToken: (token: string) => _set({ token }),
        setUser: (user: ProfileData) => _set({ isAuth: true, user }),
        setIsAuth: (isAuth: boolean) => _set({ isAuth }),
        setUserBalance: (balance: number) => {
          const user = _get().user;
          if (user) {
            _set({
              user: {
                ...user,
                balance: {
                  ...user.balance,
                  amount: Number(balance),
                  currency: user.balance.currency || "EUR",
                  bonus: user.balance.bonus || 0,
                },
              },
            });
          }
        },
      }),
      { name: "user-storage" },
    ),
  ),
);

export default UserStore;
